import React, { useEffect } from 'react';

import { ChatListTable } from '../components/ChatListTable';
import { useLazyReadChatsQuery } from '../../../../communities/components/Chats/service/chat.api';
import { useAppSelector } from '../../../../../store';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const ChatListContainer = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [
        getChats,
        { data: chats = { items: [], total: 0 }, isFetching, isLoading },
    ] = useLazyReadChatsQuery();

    useEffect(() => {
        if (filters) {
            getChats(filters, true);
        }
    }, [filters]);

    const loading = isFetching || isLoading;

    return <ChatListTable loading={loading} source={chats} />;
};
